import { memo, useEffect, useState } from "react";
import { useAuth } from "../../context/loginContext.js";
import { useDashboard } from "../../context/dashboardContext.js";
import { Link } from "react-router-dom";
import axiosAWS from '../../api/configAxios.js';
import Cookie from "js-cookie";
import $ from 'jquery';
import { ButtonToolbar, OverlayTrigger, Popover, Button } from "react-bootstrap";

var cat_grupos = [];

const Sidebar = () => {

    const { apartados } = useDashboard();
    const { user, obtener_data } = useAuth();
    const [carga_apartado, setCargaApartados] = useState(false);
    const [apartadoslink, setApartadoslink] = useState([]);

    const get_data_consulta = async (url, data) => {
        //console.log(data);
        var result = null;
        try {
            const cookies = Cookie.get();
            var result_auth = null;

            result_auth = await axiosAWS.post(url, data, { headers: { 'Authorization': `Bearer ${cookies.AutKeyPbi}` } }).catch(function (error) {
                if (error.response.status === 400) {
                    //console.log("error 400");
                }

                if (error.response.status >= 500) {
                    //console.log("algo anda mal con la el servidor");
                }
            });

            //console.log(result_auth);

            if (result_auth.status >= 200 || result_auth.status <= 299) {
                if (result_auth.data.hasOwnProperty("result")) {
                    if (result_auth.data.result !== null) {
                        result = result_auth.data.result;

                    } else {
                        alert("sin datos presentes");
                    }

                }

            } else {
                alert("usuario denegado");
            }

            return result;
        } catch (error) {

            //console.log("error servidorAWS");
            return "error";
        }
    }

    const get_catalogos = async (refresh) => {
        setCargaApartados(true)
        var result_cat = [];

        if (refresh) {
            obtener_data();
        }

        if (cat_grupos.length === 0 || refresh) {
            //validamos las cookies
            console.log("si cargo")
            result_cat = await get_data_consulta("catalogos/", { type: "Cat_gtableros_sidervar" });
            result_cat = result_cat[0];
            cat_grupos = result_cat;

        } else {
            result_cat = cat_grupos;
        }

        if (result_cat.length === 0) {
            setCargaApartados(false)
            return
        }



        var id_inicial = result_cat[0].uuid_grupo_tablero;
        var nombreTt = result_cat[0].Gtablero_titulo;
        var apartados_content = [];
        var apartados_pp = []

        //console.log(result_cat)
        result_cat.forEach(row => {

            // accordion-collapse collapse show
            if (id_inicial !== row.uuid_grupo_tablero) {
                apartados_pp.push(
                    (
                        <div className="accordion accordion-flush " id={"gurp-" + id_inicial} key={"gup" + id_inicial}>
                            <div className="accordion-item ">
                                <h2 className="accordion-header">
                                    <button className="accordion-button bg-body-secondary collapsed" type="button" data-bs-toggle="collapse" data-bs-target={"#flush-" + id_inicial} aria-expanded="true" aria-controls={"flush-" + id_inicial}>
                                        {nombreTt}
                                    </button>
                                </h2>
                                <div id={"flush-" + id_inicial} className="accordion-collapse collapse" data-bs-parent={"#gurp-" + id_inicial}>
                                    <ul className="navbar-nav pt-2 pb-2">
                                        {apartados_content}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    )

                );
                apartados_content = [];
                nombreTt = row.Gtablero_titulo;
                id_inicial = row.uuid_grupo_tablero;
            }


            //row.uuid_tablero !== null
            if (row.uuid_tablero !== null) {
                var add_jx = (<li className={"nav-item dropdown me-1 ms-1 ps-3 mb-1 " + (apartados === ("tablero" + id_inicial + "|" + row.uuid_tablero) ? "active-vi" : "n-ink")} key={"tbls-" + row.uuid_tablero}>
                    <Link className={"nav-link "} to={("/tablero?tbl=" + id_inicial + "|" + row.uuid_tablero)}><i className={"bi " + (apartados === ("tablero" + id_inicial + "|" + row.uuid_tablero) ? "bi-align-end" : "bi-align-start") + " on-ico-1"}></i><i className="bi bi-align-middle on-ico-2"></i> {row.tablero_titulo}</Link>
                    <div className="popover_mo">
                        <ButtonToolbar>
                            <OverlayTrigger
                                trigger={['hover', 'focus']}
                                placement="right"
                                overlay={popoverHoverFocus(row.tablero_nota)}
                            >
                                <i className="bi bi-info-circle"></i>
                            </OverlayTrigger>
                        </ButtonToolbar>
                    </div>

                </li>)
                apartados_content.push(add_jx);
            }


        });


        apartados_pp.push(
            (
                <div className="accordion accordion-flush " id={"gurp-" + id_inicial} key={"gup" + id_inicial}>
                    <div className="accordion-item ">
                        <h2 className="accordion-header">
                            <button className="accordion-button bg-body-secondary collapsed" type="button" data-bs-toggle="collapse" data-bs-target={"#flush-" + id_inicial} aria-expanded="true" aria-controls={"flush-" + id_inicial}>
                                {nombreTt}
                            </button>
                        </h2>
                        <div id={"flush-" + id_inicial} className="accordion-collapse collapse" data-bs-parent={"#gurp-" + id_inicial}>
                            <ul className="navbar-nav pt-2 pb-2">
                                {apartados_content}
                            </ul>
                        </div>
                    </div>
                </div>
            )

        );


        setApartadoslink(apartados_pp);
        setCargaApartados(false)
        //console.log(apartadoslink);

        /*
        active-vi -> para activar el link
        n-ink -> para activar el hover del link
        */

    }

    const popoverHoverFocus = (texto) => {
        return (
            <Popover className="p-2" id="popover-trigger-hover-focus" title="Popover bottom">
                {texto}
            </Popover>
        );
    }

    useEffect(()=>{
        cat_grupos.length = 0
    },[])

    useEffect(() => {

        get_catalogos(false);

    }, [apartados])



    return (
        <>
            <div className="offcanvas offcanvas-start bg-body-secondary" data-bs-scroll="true" tabIndex={-1} id="offcanvasWithBothOptions" aria-labelledby="offcanvasWithBothOptionsLabel">
                <div className="offcanvas-header">
                    <h5 className="offcanvas-title" id="offcanvasWithBothOptionsLabel">Menú</h5>
                    <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close" />
                </div>
                <div className="offcanvas-body ps-0 pe-0">
                    <ul className="navbar-nav pt-2 pb-2">
                        {/**
                          <li className={"nav-item dropdown me-1 ms-1 ps-3 " + (apartados === "panel-control" ? "active-vi" : "n-ink")}>
                            <Link className={"nav-link "} to={"/panel-control"}><i className={"bi " + (apartados === "panel-control" ? "bi-align-end" : "bi-align-start") + " on-ico-1"}></i><i className="bi bi-align-middle on-ico-2"></i> panel de control</Link>
                        </li>
                        */}


                        {
                            carga_apartado ?
                                <li className={"nav-item dropdown me-1 ms-1 ps-3 "}>
                                    <Link className={"nav-link "} ><i className={"bi on-ico-1"}></i><i className="bi bi-cloud-download-fill"></i> Buscando Tableros...</Link>
                                </li>
                                :
                                <>

                                    {
                                        carga_apartado ?
                                            <></>
                                            :
                                            <li className={"nav-item dropdown me-1 ms-1 ps-3 n-ink"}>
                                                <Link className={"nav-link "} to={"/home"} onClick={() => { get_catalogos(true) }}><i className="bi bi-arrow-counterclockwise"></i> Refrescar apartados</Link>
                                            </li>

                                    }




                                    {
                                        user !== null ?
                                            user.rol_titulo === "Administrador" ?
                                                <li className={"nav-item dropdown me-1 ms-1 ps-3 " + (apartados === "panel-control" ? "active-vi" : "n-ink")}>
                                                    <Link className={"nav-link "} to={"/panel-control"}><i className={"bi " + (apartados === "panel-control" ? "bi-align-end" : "bi-align-start") + " on-ico-1"}></i><i className="bi bi-align-middle on-ico-2"></i> panel de control</Link>
                                                </li>
                                                :
                                                <></>
                                            :
                                            <></>
                                    }

                                    <li className={"nav-item dropdown me-1 ms-1 ps-3 " + (apartados === "home" ? "active-vi" : "n-ink")}>
                                        <Link className={"nav-link "} to={"/home"}><i className={"bi " + (apartados === "home" ? "bi-align-end" : "bi-align-start") + " on-ico-1"}></i><i className="bi bi-align-middle on-ico-2"></i> Home</Link>
                                    </li>

                                    {apartadoslink}

                                </>
                        }
                    </ul>



                    {/*
                    <div className="accordion accordion-flush " id="accordionFlushExample">
                        <div className="accordion-item ">
                            <h2 className="accordion-header">
                                <button className="accordion-button bg-body-secondary" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="true" aria-controls="flush-collapseOne">
                                    Tableros Martín
                                </button>
                            </h2>
                            <div id="flush-collapseOne" className="accordion-collapse collapse show" data-bs-parent="#accordionFlushExample">
                                <ul className="navbar-nav pt-2 pb-2">
                                    <li className="nav-item dropdown me-1 ms-1 ps-3 active-vi">
                                        <button className={"nav-link "} ><i className="bi bi-align-end on-ico-1"></i><i className="bi bi-align-middle on-ico-2"></i> INEGI AUTOCOM</button>
                                    </li>
                                    <li className="nav-item n-ink dropdown me-1 ms-1 ps-3">
                                        <button className={"nav-link "} ><i className="bi bi-align-start on-ico-1"></i><i className="bi bi-align-middle on-ico-2"></i> Ventas Totales</button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    */}

                </div>
            </div>
        </>
    );

}

export default memo(Sidebar);